import { lazy } from "react";
import { connect } from "react-redux";
import { loading } from "../../../../store/administration/selectors/ubications";

const NewUbication = lazy(() => import("./NewUbication"));

const mapStateToProps = (state) => ({
  loading: loading(state),
});

export default connect(mapStateToProps)(NewUbication);
